/**
 * External Dependencies
 */
// import 'jquery';
import Headroom from "headroom.js";
import 'detect_swipe/jquery.detect_swipe';
import 'slick-carousel'
import featherlight from 'featherlight';
import featherlightGallery from './featherlight-gallery';

import Alpine from 'alpinejs'

window.Alpine = Alpine

// Nav
Alpine.data('menu', () => {
  let menuElements = document.querySelectorAll('.nav-main-mobile li:not(.menu-item-has-children)');
  for (let i = 0, il = menuElements.length; i < il; ++i) {
    let menuElement = menuElements[i]
    menuElement.setAttribute('x-on:click', "menuOpen = false");
  }

  return {
    domainOpen: false,
    menuOpen: false,
  }
});

Alpine.start()

// Headroom
let hx_admin = 0;
if (document.getElementById('wpadminbar')) {
  hx_admin = document.getElementById('wpadminbar').offsetHeight;
}
let hx_infobar = 0;
let hx_toolbar = 0;
if (document.getElementById('toolbar')) {
  hx_toolbar = document.getElementById('toolbar').offsetHeight;
}
let hx_main = 0;
if (document.getElementById('main-navigation')) {
  hx_main = document.getElementById('main-navigation').offsetHeight;
}
let hx_sub = 0;
if (document.getElementById('sub-navigation')) {
  hx_sub = document.getElementById('sub-navigation').offsetHeight;
}

let header = document.querySelector('.header');
if(header !== null) {
  let headroom = new Headroom(
    header,
    {
      offset: {
        up: 100,
        down: 150,
      },
      tolerance: {
        up: 5,
        down: 0,
      },
      onPin : function() {
        if (document.getElementById('wp-block-toc')) {
          document.getElementById('wp-block-toc').classList.remove('toc--unpinned');
          document.getElementById('wp-block-toc').classList.add('toc--pinned');

          if (document.getElementById('infobar')) {
            hx_infobar = document.getElementById('infobar').offsetHeight;
          }
          document.getElementById('wp-block-toc').style.top = hx_admin + hx_infobar + hx_toolbar + hx_main + hx_sub + 'px';

          spaceScrollAnchors('up');
        }
      },
      onUnpin : function() {
        if (document.getElementById('wp-block-toc')) {
          document.getElementById('wp-block-toc').classList.remove('toc--pinned');
          document.getElementById('wp-block-toc').classList.add('toc--unpinned');

          let hx_sub = 0;
          if (document.getElementById('sub-navigation')) {
            hx_sub = document.getElementById('sub-navigation').offsetHeight;
          }

          let height = document.getElementById('main-navigation').offsetHeight + hx_sub + hx_admin - 16; // 1rem
          document.getElementById('wp-block-toc').style.top = height + 'px';

          spaceScrollAnchors('down');
        }

        spaceAdditionalHeaders();
      },
    });
  headroom.init();
}

// Recalculate unpinned height (in case of multi-lie infobar height).
function spaceAdditionalHeaders() {
  let hx_toolbar = 0;
  let hx_infobar = 0;

  if (document.getElementById('toolbar')) {
    hx_toolbar = document.getElementById('toolbar').offsetHeight;
  }

  if (document.getElementById('infobar')) {
    hx_infobar = document.getElementById('infobar').offsetHeight;
  }

  let sumHeight = hx_toolbar + hx_infobar;
  jQuery('head').append('<style>.has-infobar .headroom--unpinned { transform: translateY(-' + sumHeight + 'px); }</style>');
}

// Push main content down for the sticky header.
function spaceStickyHeader() {
  if (document.getElementById('header')) {
    let headerHeight = document.getElementById('header').offsetHeight - 1;
    document.getElementById('main').style.marginTop = headerHeight + 'px';
    if (document.getElementById('wp-block-toc')) {
      document.getElementById('wp-block-toc').style.top = headerHeight + 'px';
    }
  }
}

// Add invisible additional space for scroll anchors.
function spaceScrollAnchors(direction) {
  let hx_toolbar = 0;
  let hx_infobar = 0;
  if('up' === direction) {
    if (document.getElementById('toolbar')) {
      hx_toolbar = document.getElementById('toolbar').offsetHeight;
    }

    if (document.getElementById('infobar')) {
      hx_infobar = document.getElementById('infobar').offsetHeight;
    }
  }

  let hx_main = 0;
  if (document.getElementById('main-navigation')) {
    hx_main = document.getElementById('main-navigation').offsetHeight;
  }

  let hx_sub = 0;
  if (document.getElementById('sub-navigation')) {
    hx_sub = document.getElementById('sub-navigation').offsetHeight;
  }

  let tocHeight = 0;
  if (document.getElementById('wp-block-toc') && window.innerWidth >= 1024) {
    tocHeight = document.getElementById('wp-block-toc').offsetHeight;
  }

  let padHeight = 8;
  if (window.innerWidth >= 1024) {
    padHeight = 32;
  }

  let sumHeight = hx_toolbar + hx_infobar + hx_main + hx_sub + tocHeight + padHeight;
  jQuery('head').append('<style>.wp-block-heading::before { height: ' + sumHeight + 'px !important; margin-top: -' + sumHeight + 'px !important; }</style>');
}

spaceStickyHeader();
spaceScrollAnchors();
window.addEventListener('resize', () => {
  spaceStickyHeader();
  spaceScrollAnchors();
});

$(() => {
  $('.toggle-submenu').on('click', function (e) {
    e.preventDefault();
    $(this).parent().parent().toggleClass('is-open');
  });

  // Slider
  let $sliderAdvantages = $('.js-slider-advantages');
  $sliderAdvantages.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
    // currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
    let i = (currentSlide ? currentSlide : 0) + 1;
    $('.js-slider-advantages-paging').text(i + '/' + slick.slideCount);
  });

  $sliderAdvantages.slick({
    lazyLoad: 'ondemand',
    dots: false,
    arrows: false,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: 'unslick'
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  $('.js-slider-advantages-previous').on('click', function () {
    $sliderAdvantages.slick('slickGoTo', parseInt($sliderAdvantages.slick('slickCurrentSlide')) - 1);
  });
  $('.js-slider-advantages-next').on('click', function () {
    $sliderAdvantages.slick('slickGoTo', parseInt($sliderAdvantages.slick('slickCurrentSlide')) + 1);
  });

  // Slider
  let $sliderWorkflow = $('.js-slider-workflow');
  $sliderWorkflow.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
    // currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
    let i = (currentSlide ? currentSlide : 0) + 1;
    $('.js-slider-workflow-paging').text(i + '/' + slick.slideCount);
  });

  $sliderWorkflow.slick({
    lazyLoad: 'ondemand',
    dots: false,
    arrows: false,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  $('.js-slider-workflow-previous').on('click', function () {
    $sliderWorkflow.slick('slickGoTo', parseInt($sliderWorkflow.slick('slickCurrentSlide')) - 1);
  });
  $('.js-slider-workflow-next').on('click', function () {
    $sliderWorkflow.slick('slickGoTo', parseInt($sliderWorkflow.slick('slickCurrentSlide')) + 1);
  });

  // FAQ
  $('.wp-block-yoast-faq-block .schema-faq-question').on('click', function () {
    $('.faq-opened').not($(this).parent()).removeClass('faq-opened');
    $(this).parent().toggleClass('faq-opened');
  });
});

jQuery(document).ready(function ($) {
  /**
   * Close infobar.
   */
  function removeInfobar() {
    $('body').removeClass('has-infobar');
    $('.infobar').removeClass('is-visible');
  }

  function showInfobar() {
    $('body').addClass('has-infobar');
    $('.infobar').addClass('is-visible');
  }

  function setInfobarCookie() {
    var cnTime = new Date(),
      cnLater = new Date(),
      cnValue = true;
    cnLater.setTime(parseInt(cnTime.getTime()) + parseInt(86400) * 1000); // One day.
    document.cookie = 'infobar_accepted=' + cnValue + ';expires=' + cnLater.toUTCString() + ';path=/;';
  }

  if (document.cookie.indexOf('infobar_accepted') === -1) {
    if($('.infobar').length) {
      showInfobar();
      spaceStickyHeader();
    }
  } else {
    removeInfobar();
  }

  $('.js-alert-close, .js-toggle-menu').on('click', function () {
    setInfobarCookie();
    removeInfobar();
    spaceStickyHeader();
  });

  // Reset radio input fields.
  $('.ginput_container_radio').parent().find('.gfield_label').append(' ').append('(Auswahl zurücksetzen)').on('click', function () {
    $(this).parent().find('input[type="radio"]:checked').prop('checked', false).trigger('change');
  });
});

// Show scroll to top button based on scroll depth.
window.addEventListener('scroll', runOnScroll)

function runOnScroll() {
  const el = document.querySelector('.js-scroll-top')
  if (el !== null) {
    if (window.scrollY > 150) {
      el.classList.add('active')
    } else {
      el.classList.remove('active')
    }
  }
}
